import React from 'react';
import { Field } from 'formik';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';
const { degreeTypes } = require('buyside/util/constantsFromRails.json');

const DegreesAndCertifications = ({ isMobile }) => (
  <Field
    component={CheckboxesField}
    name="minimum.degreesAndCertifications"
    options={[...degreeTypes.undergrad, ...degreeTypes.graduate, 'CFA']}
    numColumns={isMobile ? 2 : 3}
  />
);

export default DegreesAndCertifications;
